module.exports = __webpack_public_path__ + "img/union1Img.b437d8a2.png";